import { gql } from 'apollo-angular';

export const QUERY_GET_EQUIPMENT_COUNTING_JOURNAL_USER_COUNTS = gql`
  query getEquipmentCountingJournalUserCounts($journalId: String!) {
    getEquipmentCountingJournalUserCounts(journalId: $journalId) {
      userId
      userName
      count
    }
  }
`;